import store from '@/store/index';

/** 论坛接口使用的 uid，来自账号中心的 game_user_id */
export const getForumUid = () => {
  const userInfo = store.state.account && store.state.account.userInfo;
  if (!userInfo || typeof userInfo !== 'object') return '';
  return userInfo.game_user_id || '';
};
